<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY</span><br/>A<span class="smallcaps">LAN</span> P<span class="smallcaps">ARKS</span></h1>
<p class="center"><i>Bloody January</i></p>
<p class="center"><i>February’s Son</i></p>
<p class="center"><i>Bobby March Will Live Forever</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// the-april-dead_00000.vue?6f55ef90